import { isEmpty, get } from "lodash";

import { tagTypeHasMandatoryAttributes } from "src/hooks/useTagFormValidator";
import {
  tagTypeHasMandatoryEntityAttributes,
  entityTagFromApplyResult,
  getCreatedEntityTagFromApplyResult,
} from "./TagsEditor.util";

export type UserCreatedTagFlow =
  | "create-modal"
  | "attributes-modal"
  | "display-value-modal";

export const userCreatedTagFlow = (tagTypeConfig): UserCreatedTagFlow => {
  if (tagTypeHasMandatoryEntityAttributes(tagTypeConfig)) {
    return "create-modal";
  }
  if (!isEmpty(get(tagTypeConfig, "attributes.values"))) {
    return "attributes-modal";
  }
  if (tagTypeHasMandatoryAttributes(tagTypeConfig)) {
    return "create-modal";
  }
  return "display-value-modal";
};

export const entityTagForMandatoryUniqueAttrs = (
  selectedTag,
  applyResult,
  tagTypeConfig
) => {
  const createdEntityTag = getCreatedEntityTagFromApplyResult(applyResult);
  if (
    !tagTypeHasMandatoryEntityAttributes(tagTypeConfig) ||
    !createdEntityTag
  ) {
    return null;
  }
  return entityTagFromApplyResult(selectedTag, createdEntityTag);
};
